import { useQuery } from '@tanstack/react-query';
import { fetchMarketBoardQuotes } from '@apis/indices';
import type { IndicesMarketGroup } from '@app-types/indices';
import type { MarketBoardQuotesApiResponse } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';

export const buildMarketBoardQuotesQueryKey = (mktGroup: IndicesMarketGroup) => [
  'marketBoardQuotes',
  mktGroup,
] as const;

export const useMarketBoardQuotes = (mktGroup: IndicesMarketGroup) => {
  const hasToken = Boolean(getAccessToken());
  return useQuery<MarketBoardQuotesApiResponse>({
    queryKey: buildMarketBoardQuotesQueryKey(mktGroup),
    queryFn: () => fetchMarketBoardQuotes({ mktGroup }),
    enabled: hasToken,
    staleTime: Infinity,
    retry: 1,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
